export default "__VITE_ASSET__CXsMq_3y__"